/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InvitationInfo interface.
 */
export function instanceOfInvitationInfo(value) {
    return true;
}
export function InvitationInfoFromJSON(json) {
    return InvitationInfoFromJSONTyped(json, false);
}
export function InvitationInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'] == null ? undefined : json['email'],
        'emailLocked': json['email_locked'] == null ? undefined : json['email_locked'],
    };
}
export function InvitationInfoToJSON(json) {
    return InvitationInfoToJSONTyped(json, false);
}
export function InvitationInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'email_locked': value['emailLocked'],
    };
}
